<template>
  <section class="w-full h-full box-border px-10 py-5 overflow-hidden">
    <data-table
      class="w-full h-full overflow-hidden"
      cell-class-name="truncate-table-cell-wrap"
      align="left"
      height="calc(100% - 48px)"
      :data="list"
      :loading="tableLoading"
      :columns="columns"
      :show-page="list.length > 0"
      :page="page"
      :show-tooltip="true"
      @size-change="changeSize"
      @pagination-current-change="changeNum"
    >
      <!-- <template #id="{ row }">
        <el-tooltip :content="`${row.id}`" effect="light">
          <span>{{ row.id }}</span>
        </el-tooltip>
      </template>
      <template #templateContent="{ row }">
        <el-tooltip :content="row.templateContent" effect="light">
          <span>{{ row.templateContent }}</span>
        </el-tooltip>
      </template> -->
      <template #totalAmount="{ row }">
        <span>{{ row.totalAmount | num2decimal }}</span>
      </template>
      <!-- <template #sendTime="{ row }">
        <el-tooltip :content="row.sendTime" effect="light" v-if="row.sendTime">
          <span>{{ row.sendTime }}</span>
        </el-tooltip>
        <span v-else>—</span>
      </template> -->
      <template #status="{ row }">
        <status :pointColor="row.status | groupStatusColor" :text="row.status | groupStatusText" />
      </template>
      <template #action="{ row }">
        <el-button v-if="isAction(row.status)" type="text" :class="row.status | groupStatusBtnColor" @click="showRecord(row)">{{
          row.status === groupState.GROUP_ERROR ? '退款记录' : '发送记录'
        }}</el-button>
        <span class="select-none cursor-not-allowed" :class="row.status | groupStatusBtnColor" v-else>发送记录</span>
      </template>
    </data-table>
  </section>
</template>

<script>
import DataTable from '@/components/base/DataTable'
import Status from '@/components/base/Status'
import { getSmsRecord } from '@/api/pay/sms'
import GlobalConfig from '@/global/config'
import { createPopup } from '@/assets/js/factory'
import { pageMixins } from '@/mixins/publish'
import { brColumns, groupStatus, groupState, sendState } from '../config/sms-sending'
import SmsRecordDialog from './SmsRecordDialog'

export default {
  name: 'SmsBatchRecord',
  mixins: [pageMixins],
  inject: {
    switchTab: {
      default: null
    },
    source: {
      default: () => ({})
    }
  },
  props: {
    recordId: {
      type: Number,
      default: 0
    }
  },
  components: {
    DataTable,
    Status
  },
  filters: {
    num2decimal(num) {
      if (typeof num !== 'number' || Number.isNaN(+num)) return '—'
      if (Number.isInteger(num)) {
        return `${num}.00`
      }
      const [zNum, pNum] = `${num}`.split('.')
      return `${zNum}.${pNum[0] ?? '0'}${pNum[1] ?? '0'}`
    },
    groupStatusText(status) {
      return groupStatus[`${status}`]?.label || '—'
    },
    groupStatusBtnColor(status) {
      let color = 'text-theme-text-gray'
      if (status === groupState.GROUP_SUCCESS || status === groupState.GROUP_ERROR) {
        color = 'text-theme'
      }
      return color
    },
    groupStatusColor(status) {
      return groupStatus[`${status}`]?.color || ''
    }
  },
  data() {
    return {
      columns: brColumns,
      list: [],
      tableLoading: false,
      groupState
    }
  },
  watch: {
    'source.activeTab': {
      handler(activeTab) {
        if (activeTab === 'batchRecord') {
          this.page.pageSize = 20
          this.searchList()
        }
      }
    }
  },
  methods: {
    getList() {
      const { currentPage, pageSize } = this.page
      const params = {
        current: currentPage,
        size: pageSize,
        descs: 'create_time',
        surveyId: GlobalConfig.getSurveyId(),
        recordId: this.recordId !== 0 ? this.recordId : null
      }
      this.tableLoading = true
      getSmsRecord(params)
        .then(res => {
          const { records, total, size, current } = res?.data?.data || {}
          this.list = records || []
          this.page.total = total ?? 0
          this.page.currentPage = current
          this.page.pageSize = size
        })
        .catch(e => {
          this.$message.error(e?.msg || '获取群发记录失败')
        })
        .finally(() => {
          this.tableLoading = false
        })
    },
    showRecord(item = {}) {
      if (item.status === groupState.GROUP_SUCCESS) {
        // 发送记录
        if (typeof this.switchTab === 'function') {
          this.switchTab('alreadySM', sm => {
            if (item.status !== null && item.status !== undefined) {
              const { GROUP_UNPAID, GROUP_SENDING, GROUP_ERROR, GROUP_SUCCESS } = groupState
              const { SEND_SENDING, SEND_SUCCESS, SEND_ERROR } = sendState
              const cState = {
                [GROUP_UNPAID]: SEND_SENDING,
                [GROUP_SENDING]: SEND_SENDING,
                [GROUP_ERROR]: SEND_ERROR,
                [GROUP_SUCCESS]: SEND_SUCCESS
              }[item.status]
              if (!sm.condition.sendStatus.includes(cState)) {
                sm.condition.sendStatus.push(cState)
              }
            }
            sm.condition.recordId = item.id
            sm.notGD = true
            sm.searchList()
          })
        }
      } else if (item.status === groupState.GROUP_ERROR) {
        // 发送失败
        if (item.refundRecord) {
          createPopup(SmsRecordDialog, { source: item.refundRecord })
        } else {
          this.$message.warning('无退款记录')
        }
      }
    },
    isAction(status) {
      return status === groupState.GROUP_SUCCESS || status === groupState.GROUP_ERROR
    }
  }
}
</script>
